import React, { Component } from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SideBar from '../components/SideBar';
import { IsLoggedIn, Logout } from '../services/AccountService';
import { Redirect, Route } from 'react-router-dom';
import { showWarnMessage } from '../utils/Utility';

export default class BaseLayout extends Component {
	state = { isLoggedIn: false };
	componentDidMount() {
		// eslint-disable-next-line no-undef
		$('body').layout('fix');
	}
	componentWillMount() {
		let isLoggedIn = IsLoggedIn();
		this.setState({ ...this.state, isLoggedIn: isLoggedIn });
		if (!isLoggedIn) {
			Logout();
		}
	}
	render(props) {
		let renderResult;
		if (this.state.isLoggedIn) {
			renderResult = (
				<div className="hold-transition skin-blue sidebar-mini">
					<div id="root" className="wrapper">
						<Header />
						<SideBar />
						<div className="content-wrapper">{this.props.children}</div>
						<Footer />
					</div>
				</div>
			);
		} else {
			renderResult = (
				<Redirect
					to={{
						pathname: '/login',
						state: {
							message: 'Para acessar esse recurso é necessário realizar o login e senha.',
							from: this.props.location,
						},
					}}
				/>
			);
		}
		return <Route>{renderResult}</Route>;
	}
}
